<template>
  <v-content>
    <v-sheet id="core-view" elevation=2>
      <v-fade-transition mode="out-in">
        <router-view id="router-view" />
      </v-fade-transition>
    </v-sheet>
    <!-- <core-footer v-if="$route.name !== 'Maps'" /> -->
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'RSD Wholesale'
    }
  }
}
</script>

<style>
#core-view {
  /* background: transparent; */
  width: 100%;
  max-width: 1200px;

  /* height: auto;
  min-height: 100vh; */
  
  margin-left: auto;
  margin-right: auto; 

}


</style>
